import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { canAccess } from "@/lib/permissions";

export default function ProtectedRoute({ children, adminOnly = false, module = null }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-zinc-500 text-sm">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  if (module && !canAccess(user.role, module)) return <Navigate to="/" replace />;
  return children;
}
